import * as React from 'react';
import type { ReactNode } from 'react';

interface FormLabelProps {
    label: ReactNode | ((asterisk: ReactNode) => ReactNode);
    required?: boolean;
}

const Asterisk = () => <span aria-hidden>{` * `}</span>;

export const FormLabel: React.FC<React.PropsWithChildren<FormLabelProps>> = ({ label, required = false }) => (
    <>
        {typeof label === 'function' ? (
            label(required ? <Asterisk /> : ' ')
        ) : (
            <>
                {label}
                {required && <Asterisk />}
            </>
        )}
    </>
);
